import { useSelector } from 'react-redux'
import { useState } from 'react'
import { ReactComponent as MiniDivisionBadge } from '../../../../assets/images/common/icons/mini-division-badge.svg'
import { ReactComponent as Logo } from '../../../../assets/images/logos/horizontal-logo.svg'
import { splitArray } from '../../../../utility/arrayHelper'
import { levelColors } from '../../../../utility/curriculumHelper'

import classes from './Scoreboards.module.scss'
import classNames from 'classnames'
import { useEffect } from 'react'

const Scoreboards = () => {
  const event = useSelector(state => state.nineHoleEvent)
  const timestamp = new Date().getTime()
  const community = useSelector(state => state.user.current_user.communities[0])

  const [levels, setLevels] = useState ([])

  useEffect(() => {
    const newLevels = [
      { order: 1, yardHoles: 25, yards: 225, students: [] },
      { order: 2, yardHoles: 50, yards: 450, students: [] },
      { order: 3, yardHoles: 100, yards: 900, students: [] },
      { order: 4, yardHoles: 150, yards: 1350, students: [] },
      { order: 5, yardHoles: 200, yards: 1800, students: [] },
      { order: 6, yardHoles: 'Full Tee Box', yards: 1801, students: [] },
    ]
    const students = event.pairings.id !== -1
      ? event.students.filter(s => s.status === 'confirmed')
      : event.students.filter(s => s.status !== 'declined')
    students.forEach((student) => {
      const level = newLevels[Math.min(student.level, 6) - 1]
      level.students.push(student)
    })

    newLevels.forEach(level =>
      level.pagedStudents = splitArray(level.students, 4)
    )

    setLevels(newLevels.filter(level => level.pagedStudents.length !== 0))
  }, [event.pairings.id, event.students])

  return (
    <div id='scoreboards' className={classes.scoreboards}>{
      levels.map((level) =>
        <>
          <div className={classNames('ScoreBoardsPage', classes.page)} key={level.order}>
            <div className={classes.communityLogos}>
              <div className={classNames('round-image-wrapper', classes.communityLogo)}>
                <img
                  className='round-image'
                  src={`${community.photo?.file_url}${timestamp}`}
                  alt={community.name}
                  crossOrigin='anonymous'
                />
              </div>
              <div className={classNames('round-image-wrapper', classes.communityLogo)}>
                <img
                  className='round-image'
                  src={`${community.photo?.file_url}${timestamp}`}
                  alt={community.name}
                  crossOrigin='anonymous'
                />
              </div>
            </div>
            <div className={classes.pageContent}>
              <Logo className={classes.op36Logo}/>
              <div className={classes.level}>
                <span style={{ color: levelColors[level.order] }}>LEVEL {level.order}{level.order === 6 && '+'}</span>
              </div>
              <div className={classes.yards}>
                {level.yards} yards{level.yards === 1801 && '+'}
              </div>
              <div className={classes.yardHoles}>
                ({level.yardHoles} {level.yards !== 1801 && 'yard holes'})
              </div>
            </div>
          </div>
          {
            level.pagedStudents.map((students, index) =>
              <div className={classNames('ScoreBoardsPage', classes.page)} key={`${level.order}-${index}`}>
                <div className={classes.studentsPageContent}>
                  <div className='d-flex justify-content-between'>
                    <div className='d-flex align-items-center'>
                      <div className={classNames('round-image-wrapper', classes.communityLogo)}>
                        <img
                          className='round-image'
                          src={`${community.photo?.file_url}${timestamp}`}
                          alt={community.name}
                          crossOrigin='anonymous'
                        />
                      </div>
                      <span className={classes.communityName}>
                        {community.name}
                      </span>
                    </div>
                    <Logo className={classes.op36Logo}/>
                  </div>
                  <div className={classes.studentsHeader}>
                    <p className={classes.playerName}>Player Name</p>
                    <span className='mr-4'>Personal Best</span>
                    <span className='ml-2'>Score</span>

                  </div>
                  {
                    students.map((student) =>
                      <div className='d-flex' key={student.id}>
                        <div className={classes.studentWrapper}>
                          <MiniDivisionBadge fill={levelColors[student.level]} className={classes.levelBadge}/>
                          <span className={classes.studentLevel} style={{ color: levelColors[student.level] }}>{student.level}</span>
                          {student.firstName} {student.lastName}
                        </div>
                        <div className={classes.scoreWrapper}>
                          <span className={classes.recordScore}>{student.stats[student.level].recordScore}</span>
                        </div>
                        <div className={classes.scoreWrapper}>
                          {student.score}
                        </div>
                      </div>
                    )
                  }
                </div>
              </div>
            )
          }
        </>
      )
    }
    </div>
  )
}

export default Scoreboards
